const { NODE_ENV } = process.env;

export const isDevelopment = NODE_ENV === "development";

export const API_URL = window.location.origin;

/**
 * Funktioner som är dolda i Finansportalen. Koden finns kvar – sätt flaggan
 * till true för att visa funktionen igen. Sök på `FEATURES.` för alla ställen.
 */
export const FEATURES = {
  /** Köp/Sälj/Byt-knappar och modaler, samt Avbryt order */
  trading: false,
  /** Hållbarhetssidan (fliken och routen /sustainability) */
  sustainability: false,
};
